import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import { t } from '~/helpers';
import { handleExportGeneric } from '~/helpers/exportReports';
import {
  dataInRequest,
  deleteData,
  findData,
  recordFiltering,
} from '~/store/modules/linhaAbastecimento/actions';

import Form from './form';

function LinhaAbastecimento() {
  const redux = useSelector((state) => state.linhaAbastecimento);

  const statusControleVazao = [
    { label: '0', value: t('s.geral.opcoes.nao') },
    { label: '1', value: t('s.geral.opcoes.sim') },
  ];

  const header = useMemo(
    () => [
      {
        id: 'codigoposto',
        label: t('s.geral.postocomboio'),
        filter: { type: 'text' },
      },
      {
        id: 'numerolinhaabastecimento',
        label: t('s.configuracao.tanquefisico.numerosondatanquefisico'),
        filter: { type: 'text' },
      },
      {
        id: 'descricaolinhaabastecimento',
        label: t('s.configuracao.medidor.descricaomedidor'),
        filter: { type: 'text' },
      },
      {
        id: 'controlevazaolinhaabastecimento',
        label: t('s.configuracao.linhaabastecimento.controlevazao'),
        formatted: (value) =>
          statusControleVazao.find((s) => s.label === value)?.value || '',
        filter: { type: 'select', options: statusControleVazao },
      },
    ],
    []
  );

  const fieldlist = [
    'codigoposto',
    'numerolinhaabastecimento',
    'descricaolinhaabastecimento',
    'controlevazaolinhaabastecimento',
  ];

  const substituirHeader = {
    codigoposto: t('s.geral.postocomboio'),
    numerolinhaabastecimento: t(
      's.configuracao.tanquefisico.numerosondatanquefisico'
    ),
    descricaolinhaabastecimento: t('s.configuracao.medidor.descricaomedidor'),
    controlevazaolinhaabastecimento: t(
      's.configuracao.linhaabastecimento.controlevazao'
    ),
  };

  return (
    <UnidataTable
      fixed
      redux={redux}
      header={header}
      read={recordFiltering}
      find={findData}
      remove={deleteData}
      form={Form}
      keys={['idposto', 'numerolinhaabastecimento']}
      detach="numerolinhaabastecimento"
      pdf
      excel
      onExport={(formato) =>
        handleExportGeneric({
          endpoint: 'linhasabastecimentos',
          formato,
          fields: fieldlist,
          headers: substituirHeader,
          redux,
          ordination: redux.params.ordination,
          orderfield: redux.params.orderfield,
          title: 'Relatorio de Linhas de Abastecimento',
        })
      }
    />
  );
}

export default LinhaAbastecimento;
